// import React, { useState, useEffect } from 'react';
// import SecondNav from "../Navbar/SecondNav";
// import TopNavbar from "../Navbar/TopNavbar";
// import { Box, Typography, Container, Button } from '@mui/material';
// import Footer from './Footer';
// import ChatPopup from './ChatPopup';

// function About() {
//   const [currentTime, setCurrentTime] = useState(new Date());

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentTime(new Date());
//     }, 1000);
//     return () => clearInterval(timer);
//   }, []);

//   return (
//     <div style={{ width: "100%", minHeight: "100vh", backgroundColor: "#f5f5f5", overflowX: "hidden" }}>
//       <TopNavbar />
//       <SecondNav />

//       <Box sx={{ paddingTop: '160px', paddingBottom: '40px' }}>

//         {/* Hero Section */}
//         <Box
//           sx={{
//             backgroundImage: 'url("https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=600&auto=format&fit=crop&q=60")',
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             height: { xs: '400px', md: '500px' },
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             position: 'relative',
//             mb: 6,
//             '&::before': {
//               content: '""',
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               width: '100%',
//               height: '100%',
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//             },
//           }}
//         >
//           <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 'bold',
//                 color: '#ffffff',
//                 mb: 1,
//                 fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
//               }}
//             >
//               About Armour Pro
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontWeight: 'bold',
//                 color: '#ffffff',
//                 fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
//               }}
//             >
//               Wash the dirt away with us.
//             </Typography>
//           </Container>
//         </Box>

       

//         {/* Who We Are Section with background image */}
//         <Box
//           sx={{
//             py: 12,
//             mb: 6,
//             textAlign: 'center',
//             backgroundImage: 'url("https://images.unsplash.com/photo-1515928482345-d6c2e6d21740?auto=format&fit=crop&w=1050&q=80")',
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             position: 'relative',
//             '&::before': {
//               content: '""',
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               width: '100%',
//               height: '100%',
//               backgroundColor: 'rgb(10, 0, 0)',
//               zIndex: 0,
//             },
//           }}
//         >
//           <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
//             <Typography
//               variant="h3"
//               sx={{
//                 fontWeight: 700,
//                 mb: 4,
//                 fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
//                 background: 'linear-gradient(90deg, #2E9FFF, #007BFF)',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               Who We Are
//             </Typography>

//             <Box
//               sx={{
//                 backgroundColor: 'rgba(255, 255, 255, 0.9)',
//                 borderRadius: '16px',
//                 padding: '30px',
//                 boxShadow: '0 8px 24px rgba(10, 10, 11, 0.2)',
//               }}
//             >
//               <Typography
//                 variant="body1"
//                 sx={{
//                   fontSize: '1.15rem',
//                   lineHeight: 1.8,
//                   fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
//                   color: '#333',
//                 }}
//               >
//                 Armour Pro is your trusted partner in automotive care, specializing in
//                 premium nano-ceramic coatings that protect and enhance your vehicle’s
//                 appearance. With years of expertise and a passion for perfection, we
//                 deliver top-tier services tailored to your car’s needs, ensuring a
//                 showroom-quality finish every time.
//               </Typography>
//             </Box>
//           </Container>
//         </Box>

//         {/* Call to Action Section */}
//         <Box sx={{
//           py: 12,
//           mb: 4,
//           position: 'relative',
//           borderRadius: '16px',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             backgroundColor: 'rgba(0,0,0,0.6)',
//             zIndex: 0,
//           }
//         }}>
//           <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
//             <Box sx={{ textAlign: 'center', color: '#ffffff' }}>
//               <Typography
//                 variant="h4"
//                 sx={{
//                   fontWeight: 'bold',
//                   mb: 3,
//                   fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
//                   textShadow: '0 2px 4px rgba(0,0,0,0.3)'
//                 }}
//               >
//                 Protect Your Car Today!
//               </Typography>
//               <Typography
//                 variant="body1"
//                 sx={{
//                   mb: 4,
//                   fontSize: '1.1rem',
//                   fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
//                   maxWidth: '700px',
//                   margin: '0 auto',
//                   textShadow: '0 1px 2px rgba(0,0,0,0.3)'
//                 }}
//               >
//                 Discover the Armour Pro difference with our premium nano-ceramic coatings and expert application services. Book your appointment now for a free consultation.
//               </Typography>
//               <Button
//                 variant="contained"
//                 sx={{
//                   backgroundColor: '#ffffff',
//                   color: '#2E9FFF',
//                   textTransform: 'none',
//                   fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
//                   fontSize: '1.1rem',
//                   padding: '12px 40px',
//                   borderRadius: '30px',
//                   boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
//                   transition: 'all 0.3s',
//                   '&:hover': {
//                     backgroundColor: '#f0f0f0',
//                     transform: 'translateY(-3px)',
//                     boxShadow: '0 6px 20px rgba(0,0,0,0.3)'
//                   },
//                 }}
//                 component="a"
//                 href="/booking"
//               >
//                 Book Now
//               </Button>
//             </Box>
//           </Container>
//         </Box>
//        <ChatPopup/>
//       </Box>
         
//         {/* Footer */}
//         <Footer />
//     </div>
//   );
// }

// export default About;

 






















import React, { useState, useEffect } from 'react';
import SecondNav from "../Navbar/SecondNav";
import TopNavbar from "../Navbar/TopNavbar";
import { Box, Typography, Container, Button, Grid } from '@mui/material';
import Footer from './Footer';
import ChatPopup from './ChatPopup';
import { motion } from 'framer-motion';

function About() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{ width: "100%", minHeight: "100vh", backgroundColor: "#f5f5f5", overflowX: "hidden" }}>
      <TopNavbar />
      <SecondNav />

      <Box sx={{ paddingTop: '160px', paddingBottom: '40px' }}>

        {/* Hero Section */}
        <Box
          sx={{
            backgroundImage: 'url("https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=600&auto=format&fit=crop&q=60")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: { xs: '400px', md: '500px' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            mb: 6,
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
          }}
        >
          <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
            <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#ffffff', mb: 1 }}>
              About Armour Pro
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#ffffff' }}>
              Wash the dirt away with us.
            </Typography>
          </Container>
        </Box>

        {/* Who We Are Section */}
          <Container sx={{ py: 10 }}>
  <motion.div
    whileHover={{ scale: 1.02 }}
    transition={{ duration: 0.5 }}
  >
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="nowrap"
      gap={6}
    >
      {/* Left Side: Image */}
      <motion.img
        src="https://img.freepik.com/free-photo/white-coupe-sport-car-standing-road-front-view_114579-4005.jpg"
        alt="Who We Are Car"
        style={{
          width: '50%',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        }}
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      />

      {/* Right Side: Text Content */}
      <motion.div
        style={{ width: '50%' }}
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
          Who We Are
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: '1.1rem',
            color: '#555',
            lineHeight: 1.8,
          }}
        >
          Armour Pro is your trusted partner in automotive care,
          specializing in premium nano-ceramic coatings that protect
          and enhance your vehicle’s appearance. With years of expertise
          and a passion for perfection, we deliver top-tier services
          tailored to your car’s needs, ensuring a showroom-quality finish
          every time.
        </Typography>
      </motion.div>
    </Box>
  </motion.div>
</Container>


        {/* Precision Car Care Section */}
            <Container sx={{ py: 10 }}>
  <motion.div
    whileHover={{ scale: 1.02 }}
    transition={{ duration: 0.5 }}
  >
    <Grid
      container
      spacing={6}
      alignItems="center"
      direction="row"
      flexWrap="nowrap" // Ensure they stay side-by-side
    >
      {/* Left Side: Content */}
      <Grid item xs={6}>
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
            Precision Car Care
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: '1.1rem',
              color: '#555',
              lineHeight: 1.8,
            }}
          >
            At Armour Pro, we use state-of-the-art ceramic technology to
            deliver unmatched paint protection, scratch resistance, and UV
            shielding. Every application is handled by trained professionals
            to ensure lasting results and a stunning gloss.
          </Typography>
        </motion.div>
      </Grid>

      {/* Right Side: Image */}
      <Grid item xs={6}>
        <motion.img
          src="https://img.freepik.com/free-photo/view-3d-car_23-2150796980.jpg"
          alt="Precision Car"
          style={{
            width: '100%',
            borderRadius: '5px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          }}
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        />
      </Grid>
    </Grid>
  </motion.div>
</Container>


        {/* Call to Action Section */}
        <motion.div whileHover={{ scale: 1.02 }} transition={{ duration: 0.5 }}>
          <Box sx={{
            py: 12,
            mb: 4,
            position: 'relative',
            borderRadius: '16px',
            backgroundImage: 'url("https://img.freepik.com/free-photo/3d-car-vibrant-city-night_23-2150796972.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.6)',
              zIndex: 0,
            }
          }}>
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
              <Box sx={{ textAlign: 'center', color: '#ffffff' }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>
                  Protect Your Car Today!
                </Typography>
                <Typography variant="body1" sx={{ mb: 4, fontSize: '1.1rem', maxWidth: '700px', margin: '0 auto' }}>
                  Discover the Armour Pro difference with our premium nano-ceramic coatings and expert application
                  services. Book your appointment now for a free consultation.
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: '#ffffff',
                    color: '#2E9FFF',
                    textTransform: 'none',
                    fontSize: '1.1rem',
                    padding: '12px 40px',
                    borderRadius: '30px',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s',
                    '&:hover': {
                      backgroundColor: '#f0f0f0',
                      transform: 'translateY(-3px)',
                      boxShadow: '0 6px 20px rgba(0,0,0,0.3)'
                    },
                  }}
                  component="a"
                  href="/booking"
                >
                  Book Now
                </Button>
              </Box>
            </Container>
          </Box>
        </motion.div>

        <ChatPopup />
      </Box>

      <Footer />
    </div>
  );
}

export default About;